import { html } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';

export const emTemplate = (
  node: HTMLElement,
) => html`<strong>${unsafeHTML(node.innerHTML)}</strong>`;
